import React from 'react';

interface ContentTourProps {
  image?: string;
  imageAlt?: string;
  height?: string;
}

export default function ContentTour({
  image,
  imageAlt,
  height = 'h-[215px]',
}: ContentTourProps) {
  if (!image) return null;

  return <img src={image} alt={imageAlt} className={height} />;
}
